// Generated by scripts/mdi/import-questionnaires.mjs from MDI "1. NAD+ refill 09.17.26" (3279462e-cb08-45f7-9093-b333aba8d52b). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiNADRefillQuestions = [
  {
    field: 'mdiNADRefill_changesMedicalHistorySinceLast',
    label:
      'Do you have any changes to your medical history since you last received this prescription?',
    type: 'select',
    educationalSlide:
      'If yes, please provide as much information as possible so your doctor can determine if your refill is safe and appropriate.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '46649274-dc2e-4661-88f6-2e36ac8e803c' }
  },
  {
    field: 'mdiNADRefill_newAllergiesSinceLastPrescription',
    label:
      'Do you have any new allergies since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'dd19b02c-9819-4d8a-91d3-0b7125b7e5e7' }
  },
  {
    field: 'mdiNADRefill_diagnosedCancerSinceLastPrescription',
    label:
      'Have you been diagnosed with cancer since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '8e80fdb7-0faf-437f-afa9-a13330e74cef' }
  },
  {
    field: 'mdiNADRefill_diagnosedLiverKidneyDiseaseSince',
    label:
      'Have you been diagnosed with any liver or kidney disease since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'a542754a-8083-4295-b06c-bbc42fbb6e3f' }
  },
  {
    field: 'mdiNADRefill_erVisitsHospitalizationsSinceLast',
    label:
      'Have you had any ER visits or hospitalizations since your last prescription was filled?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'ee01672a-3eaf-492d-b904-9f883e99b5f1' }
  },
  {
    field: 'mdiNADRefill_havingSideEffectsCurrentTreatment',
    label: 'Are you having any side effects from your current treatment?',
    type: 'select',
    educationalSlide: 'If yes, please provide as much information as possible.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'yes_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'bb2cd8e0-b9b7-4f6c-b2b2-2404e892b811' }
  },
  {
    field: 'mdiNADRefill_describeExperienceCurrentNadDosage',
    label:
      'How would you describe your experience with your current NAD+ dosage since your last fill?',
    type: 'select',
    educationalSlide: 'Select the option that best describes you:',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'minimal_or_no_improvements_and_no_side_e',
          value: 'Minimal or no improvements, and no side effects.'
        },
        {
          key: 'good_results_improved_energy_focus_or_re',
          value:
            'Good results (improved energy, focus, or recovery). with no or manageable side effects.'
        },
        {
          key: 'experiencing_uncomfortable_side_effects',
          value:
            'Experiencing uncomfortable side effects (e.g., severe nausea, anxiety, chest tightness, severe flushing, or headaches).'
        }
      ]
    },
    extras: { mdiQuestionId: 'f09364f3-2d79-44ec-b67a-134991617816' }
  },
  {
    field: 'mdiNADRefill_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiNADRefill_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: '7a232551-f28d-4f04-81b5-b22aeefeb7a7' }
  },
  {
    field: 'mdiNADRefill_messageDoctorLetThemKnow',
    label:
      'This is your message to your doctor, please let them know how you are doing on your current treatment and why you want to continue on your treatment.',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiNADRefill_messageDoctorLetThemKnow',
      rows: 4
    },
    extras: { mdiQuestionId: '76026993-79ec-4e2b-afc2-21879b691ba5' }
  },
  {
    field: 'mdiNADRefill_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiNADRefillAnswerField = Partial<
  QuestionAnswerMap<typeof mdiNADRefillQuestions>
>;

export default mdiNADRefillQuestions;
